import React from "react";

import {
  ActionButton,
  BottomActionSheet,
  CancelButton,
  HeaderLabel,
  HeaderSubtitle,
  HeaderTitle,
  SheetCard,
  SheetHeader,
} from "../../../../../../components/BottomActionSheet";
import { LiabilityActionSheetProps } from "./types";

export const LiabilityActionSheet: React.FC<LiabilityActionSheetProps> = ({
  name,
  subtitle,
  isOpen,
  dropdownActions,
  onClose,
}) => {
  const visibleActions = dropdownActions.filter(
    (action) => action.show !== false,
  );

  const runAction = (action: () => void) => {
    action();
    onClose();
  };

  return (
    <BottomActionSheet
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel="Liability actions"
    >
      <SheetCard>
        <SheetHeader $column>
          <HeaderLabel>Liability</HeaderLabel>
          <HeaderTitle>{name}</HeaderTitle>
          {subtitle && <HeaderSubtitle>{subtitle}</HeaderSubtitle>}
        </SheetHeader>
        {visibleActions.map((action) => {
          const variant =
            action.variant === "destructive" ? "destructive" : undefined;
          return (
            <ActionButton
              key={action.id}
              type="button"
              $centered
              $variant={variant}
              disabled={action.disabled}
              onClick={() => runAction(action.onClick)}
            >
              {action.label}
            </ActionButton>
          );
        })}
      </SheetCard>
      <SheetCard>
        <CancelButton type="button" onClick={onClose}>
          Cancel
        </CancelButton>
      </SheetCard>
    </BottomActionSheet>
  );
};
